import { AccessControl } from 'src/app/shared/authentication/access-control';
import { DashboardWidgetDefinition } from 'src/app/shared/dashboard-grid';
import { INCIDENT_GROUPINGS, IncidentGrouping } from './incident-groupings';

export interface IncidentBreakdownSettings {
  groupBy: IncidentGrouping;
}

/** How many incidents are open in each category, severity or status, largest first. */
export const INCIDENT_BREAKDOWN_WIDGET: DashboardWidgetDefinition<IncidentBreakdownSettings> = {
  type: 'incident-breakdown',
  title: 'Dashboard.IncidentBreakdown.Title',
  description: 'Open incidents counted by category, severity or status.',
  icon: 'bar_chart',
  loadComponent: () => import('./incident-breakdown-widget.component').then((m) => m.IncidentBreakdownWidgetComponent),
  size: { default: { w: 4, h: 4 }, min: { w: 3, h: 3 } },
  defaultSettings: { groupBy: 'category' },
  settingsSchema: {
    type: 'object',
    properties: { groupBy: { type: 'string', enum: Object.keys(INCIDENT_GROUPINGS) } },
    required: ['groupBy'],
  },
  loadSettingsComponent: () =>
    import('./incident-breakdown-settings.component').then((m) => m.IncidentBreakdownSettingsComponent),
  /** Boxwood's report/count needs event activity view on top of the event view the Incidents page needs */
  permissions: [AccessControl.IncidentPermissionIncidentEventView, AccessControl.IncidentPermissionEventActivityView],
  maxInstances: Infinity,
};
